import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue-proformables-card',
  templateUrl: './issue-proformables-card.component.html',
  styleUrls: ['./issue-proformables-card.component.scss'],
})
export class IssueProformablesCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
